/*
 * Title: Leaderboard/TabHead.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: Leaderboard tabs title and close only shows on desktop
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import * as React from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import close from "@assets/close.png";

type Props = {};

const TabHead: React.FC<Props> = (props) => {
  const creator = useSelector((state: any) => state?.creator);
  
  const cname = creator.creator.username;
  const pname = creator.program.name;

  return (
    <div className="items-center justify-between hidden lg:flex">
      {/* desktop tab header starts  */}
      <h4 className="font-normal tile-inlay-primary text-[24px] tracking-wider">
        Leaderboard
      </h4>
      <NavLink
        to={`/${cname}/${pname}/earn`}
        state="0"
        className="cursor-pointer w-[36px] h-[36px] flex items-center justify-center tile-inlay-primary gap-x-2 text-center text-xl font-semibold tracking-wider">
        <img src={close} alt="Close" className="object-contain w-4 h-4" />
      </NavLink>
      {/* desktop tab header starts  */}
    </div>
  );
};

export default TabHead;
